import React, { useState, useEffect } from 'react';
import { NumericFormat } from 'react-number-format';

import { logInfo } from 'apps/promo/helpers/clientLogger';
import { useApp, useLanguage } from 'apps/promo/hooks/selectors';
import { useNumberSeparators } from 'apps/promo/hooks/useNumberSeparators';

import PromoInputWrapper from './PromoInputWrapper';

const InputAmountForLanding = (props) => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const [isFilled, setIsFilled] = useState(!!props.value);
    const [isFocused, setFocused] = useState(false);
    const { thousandSeparator, decimalSeparator } = useNumberSeparators(lang, country);

    useEffect(() => {
        setIsFilled(props.value !== undefined);
    }, [props.value]);

    const handlerFocus = () => {
        setIsFilled(true);
        setFocused(true);
    };

    const handlerBlur = (e) => {
        setIsFilled(!!e.target.value);
        setFocused(false);
        props.onBlur?.();
    };

    const handleValueChange = (value) => {
        if (isFocused) {
            props.handleValueChange(value.floatValue);
        }
    };

    const focus = (e) => {
        if (e.currentTarget) {
            const input = e.currentTarget.firstElementChild;
            input.focus();
        } else {
            logInfo('Focus method not support');
        }
    };

    return (
        <PromoInputWrapper
            name="landingCalculator"
            isError={!isFilled && !isFocused}
            setFocus={focus}
            isFilled={isFilled}
            isFocused={isFocused}
            labelText={props.labelText}
            errorMessage={props.errorMessage}
        >
            <NumericFormat
                maxLength="14"
                value={props.value}
                onFocus={handlerFocus}
                autoComplete="off"
                allowNegative={false}
                thousandSeparator={thousandSeparator}
                decimalSeparator={decimalSeparator}
                fixedDecimalScale={true}
                decimalScale={2}
                onValueChange={handleValueChange}
                onBlur={handlerBlur}
            />
            {props.children}
        </PromoInputWrapper>
    );
};

export default InputAmountForLanding;
